export enum CurrencyCode {
    GBP = "GBP",
    EUR = "EUR",
}
